// breakpoints inside '_mixins.scss'
export const CSSBreakpoint = {
    'medium': 640,
    'large': 1024,
    'xlarge': 1200
}

export function debounce(fn, delay) {
    let timer;
    return () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            fn()
        }, delay);
    };
}